import { Button, Container, Dialog, Grid } from '@material-ui/core'
import { ContactSupportOutlined } from '@material-ui/icons'
import React, { useContext, useEffect, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { useParams } from 'react-router-dom'
import adminApi from '../../api/admin.api'
import { UserProfileContextStore } from '../../context/UserProfileContext'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import { TextButton } from '../Core/Buttons/TextButton'
import CircledPopUpFrame from '../Core/CircledPopUpFrame'
import NewFillButton from '../Core/NewFillButton'
import { PaperFoldBox } from '../Core/PaperFoldBox'
import { ReactComponent as Shield } from '../../assets/shield_empty.svg'
import './UserMvrRecord.scss'

export const UserMvrRecord = () => {
  let { userId } = useParams()
  const profileContext = useContext(UserProfileContextStore)
  const [validDLRiderState, setValidDLRiderState] = useState({
    rider: null,
    showPopup: false,
  })

  const openPopUp = declination_id => {
    const rider = profileContext.user_mvr_record.find(rider => rider.declination_id == declination_id)
    setValidDLRiderState({
      rider: rider,
      value: rider.value,
      showPopup: true,
    })
  }

  const closePopPup = () => {
    setValidDLRiderState({
      rider: null,
      showPopup: false,
    })
  }

  const validDriverLicense = async rider => {
    const res = await awaitWithLoading(
      adminApi.validUserInsuredPersonDriverLicense({
        declination_id: rider.declination_id,
        property: rider.property,
        value: rider.value,
      })
    )
    if (res.ok) {
      await getUserRecord()
      closePopPup()
    } else {
      EventEmitterService.dispatch(EventKey.DismissLoader)
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const getUserRecord = async () => {
    let res = await awaitWithLoading(adminApi.getUserMvrRecord(userId))
    if (res.ok) {
      profileContext.dispatch({ type: 'SET_USER_MVR_RECORD', data: res.data })
    } else {
      EventEmitterService.dispatch(EventKey.DismissLoader)
    }
  }

  useEffect(() => {
    getUserRecord()
  }, [])

  return (
    <>
      <Container maxWidth="md">
        <FlexView vAlignContent="center" hAlignContent="left" className=" margin-top-basic text-title bold">
          MVR Reports
        </FlexView>
        {profileContext.user_mvr_record.length > 0 ? (
          profileContext.user_mvr_record.map((rider, index) => {
            return (
              <>
                <FlexView className="bold text-body rider_title" hAlignContent="left">
                  Rider: {rider.first_name} {rider.last_name}
                </FlexView>
                <PaperFoldBox key={index} className="text-body ">
                  <Grid container spacing={3}>
                    <Grid container item xs={12}>
                      <Grid item xs={6}>
                        <FlexView column vAlignContent="center" hAlignContent="left">
                          <div className="text-body black bold margin-bottom-basic margin-top-basic">
                            {rider.is_driver_license_valid && rider.violations.length > 0
                              ? 'Lexis Nexis Post Mapping Violations found'
                              : 'Lexis Nexis Violations found'}
                          </div>
                          {rider.violations.length > 0 ? (
                            <ol className="violation_list">
                              {rider.violations.map(violation => (
                                <li className="list_item">
                                  {violation.description.replaceAll('_', ' ')},{' '}
                                  {new Date(violation.date).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                  })}
                                </li>
                              ))}
                            </ol>
                          ) : (
                            <div>None</div>
                          )}
                        </FlexView>
                      </Grid>
                      <Grid item xs={3}>
                        <FlexView vAlignContent="center" column hAlignContent="left">
                          <div className="text-body black bold margin-bottom-basic margin-top-basic">Driver License - Status</div>
                          <div className="text-body">{rider.is_driver_license_valid ? 'Valid' : 'Invalid'}</div>
                          <div className="text-body black bold margin-bottom-basic margin-top-basic">Lexis Nexis Indication</div>
                          {rider.driver_license_status.length > 0 ? (
                            <div className="text-body">
                              {rider.driver_license_status.map(status => (
                                <span>{status}, </span>
                              ))}
                            </div>
                          ) : (
                            <div className="text-body">None</div>
                          )}
                        </FlexView>
                      </Grid>
                      <Grid item xs={3}>
                        <FlexView hAlignContent="left" vAlignContent="center">
                          <TextButton
                            className="button_style"
                            disabled={rider.is_driver_license_valid}
                            onClick={() => openPopUp(rider.declination_id)}
                            text={'Change Driver License to Valid'}
                          />
                        </FlexView>
                      </Grid>
                    </Grid>
                  </Grid>
                </PaperFoldBox>
              </>
            )
          })
        ) : (
          <PaperFoldBox>
            <FlexView vAlignContent={'center'}>
              <Shield className="no-policy-shield" />
              <div className="text-body bolder gray margin-left-12">
                Could not find any violations that prevented the customer from purchasing a policy
              </div>
            </FlexView>
          </PaperFoldBox>
        )}
      </Container>

      <Dialog
        BackdropProps={{
          style: {
            backgroundColor: 'white',
            opacity: 0.9,
          },
        }}
        fullWidth
        open={validDLRiderState.showPopup}
        onClose={closePopPup}
        maxWidth={'xs'}
      >
        <FlexView className="popup" vAlignContent={'center'} hAlignContent={'center'} column>
          <div className="text-body black textcenter">
            Are you confident about changing this status for {validDLRiderState.rider?.first_name} {validDLRiderState.rider?.last_name} ?
          </div>
          <FlexView vAlignContent={'center'} hAlignContent={'center'} className="popup_buttons">
            <div className="popup_button">
              <NewFillButton onClick={() => validDriverLicense(validDLRiderState.rider)}>Yes</NewFillButton>
            </div>
            <div className="popup_button">
              <NewFillButton className="popup_button" onClick={closePopPup}>
                Cancel
              </NewFillButton>
            </div>
          </FlexView>
        </FlexView>
      </Dialog>
    </>
  )
}
